import React from "react";

const UncoverSurfaceIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 12.325H9a6 6 0 0 1-6-6v-2h3a6 6 0 0 1 6 6v10m0-6a6 6 0 0 1 6-6h3v1a6 6 0 0 1-6 6h-3"
    ></path>
  </svg>
);

export default UncoverSurfaceIcon;
